import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-O7ZBX7Z2.mjs";
import "./chunk-FPAJGGOC.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
